if (!customElements.get('button-list')) {
  class ButtonList extends HTMLElement {
    constructor() {
      super();
      this.sliderInstance = null;
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.button-list__items',
      };

      this.classes = {
        grid: 'f-flex',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      if (!this.sliderWrapper) return;

      this.enableSlider = this.dataset.enableSlider === 'true';

      if (this.enableSlider) {
        this.init();
        document.addEventListener('matchMobile', () => this.init());
        document.addEventListener('unmatchMobile', () => this.init());
      }
    }

    init() {
      // Mobile: pas de slider (swipe natif)
      if (window.FoxTheme?.config?.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      // Si déjà initialisé, on ne refait pas
      if (this.sliderInstance && typeof this.sliderInstance === 'object') return;

      // Récupère le gap depuis le CSS
      const styles = window.getComputedStyle(this.sliderWrapper);
      const gapRem =
        styles.getPropertyValue('--f-column-gap') ||
        styles.getPropertyValue('--column-gap') ||
        '1.2rem';

      // Convertit rem -> px (approx via root font-size)
      const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
      const spaceBetween = parseFloat(gapRem) * rootFontSize || 12;

      
const sliderOptions = {
  slidesPerView: 'auto',
  spaceBetween,
  watchOverflow: true,

  // ✅ Ajout : marge de fin pour que le dernier bouton soit entièrement visible
  slidesOffsetAfter: 84,

  navigation: {
    nextEl: this.section?.querySelector('.swiper-button-next'),
    prevEl: this.section?.querySelector('.swiper-button-prev'),
  },
};



      this.classList.add(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.grid);
      this.sliderWrapper.classList.add(this.classes.swiperWrapper);

      this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
      this.sliderInstance.init();

      // A11y focus -> amener la slide dans le viewport
      const focusableElements = window.FoxTheme?.a11y?.getFocusableElements?.(this) || [];
      focusableElements.forEach((element) => {
        element.addEventListener('focusin', () => {
          const slide = element.closest('.swiper-slide');
          if (!slide) return;
          const idx = this.sliderInstance.slider.slides.indexOf(slide);
          if (idx >= 0) this.sliderInstance.slider.slideTo(idx);
        });
      });

      this.sliderInstance.slider.on('progress', ({ progress }) => {
        this.updateSliderReach(progress === 0 ? 'begin' : progress === 1 ? 'end' : 'progress');
      });

      if (Shopify.designMode) {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          const { target } = e;
          const index = Number(target?.dataset?.index);
          if (!Number.isNaN(index)) this.sliderInstance.slider.slideTo(index);
        });
      }
    }

destroySlider() {
  this.classList.remove(this.classes.swiper);
  this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
  this.sliderWrapper.classList.add(this.classes.grid);

  // ✅ Reset COMPLET : Swiper/FoxTheme laisse souvent des styles inline qui bloquent le scroll natif
  this.sliderWrapper.removeAttribute('style');

  if (this.sliderInstance && typeof this.sliderInstance === 'object') {
    this.sliderInstance.slider.destroy();
    this.sliderInstance = null;
  }
}


    updateSliderReach(position) {
      this.dataset.sliderReach = position;
    }
  }

  customElements.define('button-list', ButtonList);
}


